export const isImageVariant = (mediaItem) => {
    return (mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.imageId) !== undefined;
};
